/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';

export interface IProductTag {
  id?: string;
  productId?: string;
  productType?: keyof typeof ProductType;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  timestampEntry?: number;
  tag?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IProductTag> = {
  active: false,
};
